import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Col,
  Row,
  message,
  Select,
  Card,
  Space,
} from "antd";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserRole } from "../../../generalFunctions";

function AddCustomer() {
  const location = useLocation();
  const [form] = Form.useForm();

  const [response, request] = useApi(
    "/config/customer",
    null,
    API_METHODS.POST
  );
  const [editResponse, editRequest] = useApi(
    `/config/customer/`,
    null,
    API_METHODS.PUT
  );

  const [customerTypesResponse, customerTypesRequest] = useApi(
    "/common/customer-types",
    null,
    API_METHODS.GET
  );

  const [customerTypes, setCustomerTypes] = useState([]);

  const [usersResponse, usersRequest] = useApi(
    "/config/user/dropdown",
    null,
    API_METHODS.GET
  );
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    customerTypesRequest();
    if (getUserRole() == 1) {
      usersRequest();
    }
    if (location.state) {
      form.setFieldsValue(location.state);
    }
  }, []);

  useEffect(() => {
    const data =
      customerTypesResponse.data !== BLANK_VALUE
        ? customerTypesResponse.data
        : [];
    setCustomerTypes(data);
  }, [customerTypesResponse]);

  useEffect(() => {
    const data = usersResponse.data !== BLANK_VALUE ? usersResponse.data : [];
    setUsers(data);
  }, [usersResponse]);

  useEffect(() => {
    if (response.data) {
      message.success("Customer added successfully.");
      navigate("/portal/setting/customers");
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      message.success("Customer updated successfully.");
      navigate("/portal/setting/customers");
    }
  }, [editResponse]);

  const Finish = () => {
    form
      .validateFields()
      .then((values) => {
        if (location.state) {
          editRequest(
            values,
            API_METHODS.PUT,
            `/config/customer/${location.state && location.state.id}`
          );
        } else {
          request(values, API_METHODS.POST);
        }
      })
      .catch((e) => {});
  };

  return (
    <Card title="Add Customer">
      <Form layout="vertical" form={form} onFinish={Finish}>
        <Row gutter={16}>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="customer_type_id"
              label="Customer type"
              rules={[
                { required: true, message: "Customer type is required." },
              ]}
            >
              <Select
                placeholder="Select Customer type"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {customerTypes?.length > 0 &&
                  customerTypes.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.customer_type}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="first_name"
              label="First Name"
              rules={[
                { required: true, message: "First Name is required." },
                {
                  max: 500,
                  message: "First Name should be maximum of 500 characters.",
                },
              ]}
            >
              <Input placeholder="First Name" />
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="last_name"
              label="Last Name"
              rules={[
                { required: true, message: "Last Name is required." },
                {
                  max: 500,
                  message: "Last Name should be maximum of 500 characters.",
                },
              ]}
            >
              <Input placeholder="Last Name" />
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="organisation"
              label="Organisation"
              rules={[
                {
                  max: 500,
                  message: "Organisation should be maximum of 500 characters.",
                },
              ]}
            >
              <Input placeholder="Organisation" />
            </Form.Item>
          </Col>

          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="primary_mail"
              label="Primary Email"
              rules={[
                { required: true, message: "Primary Email is required." },
                {
                  max: 500,
                  message: "Primary Email should be maximum of 500 characters.",
                },
              ]}
            >
              <Input placeholder="Primary Email" />
            </Form.Item>
          </Col>

          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="secondary_mail"
              label="Secondary Email"
              rules={[
                {
                  max: 500,
                  message:
                    "Secondary Email should be maximum of 500 characters.",
                },
              ]}
            >
              <Input placeholder="Secondary Email" />
            </Form.Item>
          </Col>

          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="primary_phone" label="Primary Phone">
              <Input placeholder="Primary Phone" />
            </Form.Item>
          </Col>

          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="alternate_phone" label="Alternate Phone">
              <Input placeholder="Alternate Phone" />
            </Form.Item>
          </Col>

          {getUserRole() == 1 && (
            <Col lg={8} md={12} sm={24} xs={24}>
              <Form.Item
                name="assigned_to"
                label="Assigned To"
                rules={[
                  { required: true, message: "Assigned To is required." },
                ]}
              >
                <Select
                  allowClear
                  showSearch
                  placeholder="Select Assigned To"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {users?.length > 0 &&
                    users.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option.username}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          )}

          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="billing_address" label="Billing Address">
              <Input placeholder="Billing Address" />
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="billing_city" label="Billing City">
              <Input placeholder="Billing City" />
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="billing_state" label="Billing State">
              <Input placeholder="Billing State" />
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="billing_country" label="Billing Country">
              <Input placeholder="Billing Country" />
            </Form.Item>
          </Col>

          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="billing_zipcode" label="Billing Zipcode">
              <Input placeholder="Billing Zipcode" />
            </Form.Item>
          </Col>

          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="shipping_address" label="Shipping Address">
              <Input placeholder="Shipping Address" />
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="shipping_city" label="Shipping City">
              <Input placeholder="Shipping City" />
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="shipping_state" label="Shipping State">
              <Input placeholder="Shipping State" />
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="shipping_country" label="Shipping Country">
              <Input placeholder="Shipping Country" />
            </Form.Item>
          </Col>

          <Col lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="shipping_zipcode" label="Shipping Zipcode">
              <Input placeholder="Shipping Zipcode" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Space style={{ float: "right" }}>
              <Form.Item label={null}>
                <Button type="default" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item label={null}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

export default AddCustomer;
